import React from 'react';
import { PlusIcon } from './Icons';
import { useAuth } from '../auth';

// Hero Section Component
export const HeroSection = ({ onCreateAd }) => {
  const { isAuthenticated } = useAuth();

  const handleCreateAd = () => {
    if (!isAuthenticated) {
      // Si l'utilisateur n'est pas connecté, on peut afficher un modal de connexion
      // ou rediriger vers la page de connexion
      alert('Vous devez vous connecter pour publier une annonce');
      return;
    }
    
    // Appeler la fonction de callback pour créer une annonce
    if (onCreateAd) {
      onCreateAd();
    }
  };

  return (
    <div 
      className="relative bg-cover bg-center h-64 flex items-center justify-center"
      style={{
        backgroundImage: `linear-gradient(rgba(59, 130, 246, 0.8), rgba(37, 99, 235, 0.8)), url('https://images.unsplash.com/uploads/14116941824817ba1f28e/78c8dff1')`
      }}
    >
      <div className="text-center text-white px-4">
        <h1 className="text-3xl font-bold mb-2">LaTeranga</h1>
        <p className="text-lg mb-6">Find everything you need, sell what you don't</p>
        <button 
          onClick={handleCreateAd}
          className="bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold flex items-center gap-2 mx-auto hover:bg-gray-100 transition-colors active:scale-95 transform"
        >
          <PlusIcon />
          Post an Ad
        </button>
      </div>
    </div>
  );
};
